// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import ArrowUpLineSvg from '@rsuite/icon-font/lib/direction/ArrowUpLine';
var ArrowUpLine = createSvgIcon({
  as: ArrowUpLineSvg,
  ariaLabel: 'arrow up line',
  category: 'direction',
  displayName: 'ArrowUpLine'
});
export default ArrowUpLine;